import React from 'react';
import PropTypes from 'prop-types';
import BaseComponent from "core/gd-components/base-component/base-component";

import FormManager from 'src/core/gd-form/common/form-manager';
import Form from 'src/core/gd-form/form/form-modal-new/form-modal-new';
import FormError from 'src/core/gd-form/common/form-error/form-error';

import SelectUser from 'core/gd-ui/select-user/select-user';

module.exports = class ModalActionAssignTo extends BaseComponent {
    static propTypes = {
        noValueLabel: PropTypes.string,
        onSubmit: PropTypes.func.isRequired,
        companyId: PropTypes.string,
        projectId: PropTypes.string.isRequired,
    };

    constructor(props) {
        super(props);

        const initFormData = {
            user: null
        };

        const formStructure = {
            fields: {
                user: {
                    type: 'select'
                }
            },
            onSubmit: this.onSubmit
        };

        this.form = new FormManager(formStructure,initFormData);
    }

    onSubmit = (result) => {
        this.props.onSubmit(result);
    };

    render() {
        let arrUsers
        if (this.props.projectId) {
            const projectUsers = gd.session.projectUsers.filterByProject(this.props.projectId)
            arrUsers = projectUsers.map((pu)=>{ return pu.user.id})
        } else {
            arrUsers = gd.session.companyUsers.filterByCompany(gd.companyId).exportToOptions().map(o=>o.value)
        }

        return (
            <Form form={this.form} submitLabel="Save">
                <div className="tbl">
                    <div className="row">
                        <div className="label">User</div>
                        <div className="element">
                            <SelectUser form={this.form}
                                        name="user"
                                        renderValue="form"
                                        options={arrUsers}
                                        canHaveNoValue={true}
                                        noValueValue={null}
                                        noValueLabel={this.props.noValueLabel}/>
                            <FormError form={this.form} name="user"/>
                        </div>
                    </div>
                </div>
            </Form>
        );
    }
}